import { Component, input, output } from '@angular/core';

export interface HrUserCardViewModel {
    userId: string;
    fullName: string;
    email: string;
    companyName?: string;
    officeName?: string;
}

@Component({
    standalone: false,
    selector: 'app-hr-user-card',
    templateUrl: './hr-user-card.component.html',
    styleUrls: ['./hr-user-card.component.scss']
})
export class HrUserCardComponent {
    readonly user = input.required<HrUserCardViewModel>();
    readonly selected = input(false);

    readonly cardClicked = output<void>();
}
